import clsx from 'clsx'
import React from 'react'

import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogReturn,
  DialogTitle,
  DialogTrigger
} from '@/components-latest/primitives/Dialog'
import ScrollArea from '@/components-latest/primitives/Scrollable'
import Separator from '@/components-latest/primitives/Separator'
import Text, { textVariants } from '@/components-latest/primitives/Text'
import { formatLengthValue } from '@/utils/css'

import Styles from './CommonModal.module.scss'

interface ICommonModalProps {
  children?: React.ReactNode
  title?: React.ReactNode
  body: React.ReactNode
  footer?: React.ReactNode
  width?: string | number
  open: boolean
  onOpenChange: (open: boolean) => void
  onGoBack?: () => void
  className?: string
  hideHeader?: boolean
  withFooterSeparator?: boolean
  withoutCloseIcon?: boolean
  scrollableBody?: boolean
  scrollAreaClass?: string
  bodyClass?: string
}

const CommonModal: React.FC<ICommonModalProps> = ({
  children,
  title,
  body,
  footer,
  width,
  open,
  onOpenChange,
  onGoBack,
  className,
  hideHeader,
  withFooterSeparator,
  withoutCloseIcon,
  scrollableBody,
  scrollAreaClass,
  bodyClass
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {children && <DialogTrigger asChild>{children}</DialogTrigger>}
      <DialogContent
        className={clsx(Styles.content, className)}
        style={
          (width
            ? {
                '--modal-content-width': formatLengthValue(width)
              }
            : {}) as React.CSSProperties
        }>
        <DialogHeader
          className={clsx(Styles.header, hideHeader && Styles.displayNone)}>
          {!!onGoBack && (
            <DialogReturn onClick={onGoBack} className={Styles.goBack} />
          )}
          {title && (
            <Text variant="nextSubtitle" weight="bold" align="center" asChild>
              <DialogTitle
                className={clsx(
                  Styles.title,
                  textVariants({ variant: 'nextSubtitle', weight: 'bold' })
                )}>
                {title}
              </DialogTitle>
            </Text>
          )}
          {!withoutCloseIcon && <DialogClose className={Styles.close} />}
        </DialogHeader>
        <Separator />
        {scrollableBody ? (
          <ScrollArea className={scrollAreaClass}>
            <DialogBody
              className={clsx(
                Styles.body,
                textVariants({ variant: 'nextSubtitle' }),
                bodyClass
              )}>
              {body}
            </DialogBody>
          </ScrollArea>
        ) : (
          <DialogBody
            className={clsx(
              Styles.body,
              textVariants({ variant: 'nextSubtitle' }),
              bodyClass
            )}>
            {body}
          </DialogBody>
        )}

        {withFooterSeparator && <Separator />}
        {footer && (
          <DialogFooter className={Styles.footer}>{footer}</DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  )
}

export type { ICommonModalProps }
export default CommonModal
